	<template>
<!-- I can't get this to work :( -->
     <va-modal
      v-model="isVisible"
      :noOutsideDismiss="true"
      :hideDefaultActions="true"
      title="Edit rule"
    >
	  <p>{{ text }}</p>

      <template slot="actions">
        <va-button @click="onConfirm">{{ confirmText }}</va-button>
        <va-button @click="onCancel">Cancel</va-button>
      </template>
    </va-modal>

</template>

<script>
// Written by Jim, btw.
export default {
	 name: 'confirm-modal',
	 
  data() {
    return {
      isVisible: true,
	}
  },
    props: ["text", "confirmText"],
	methods: {
		onConfirm() {
			this.$emit("confirm");
		},
		onCancel() {
			this.$emit("cancel");
		}
	}
}
</script>
<style lang="scss">
</style>